export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información del corresponsal"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Cuenta / Correo electrónico / Teléfono"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Cripto-dirección / Correo electrónico / Teléfono"])}
}